import { useEffect, useState } from "react";
import {
  TCSDetailsType,
  TDSDetailsType,
} from "../../../../redux/masterData/masterTypes";
import {
  DeleteTcsPayloadType,
  GetTdsMasterPayloadType,
} from "../../../../commonTypes/masterDataTypes";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../commons";
import toast, { Toaster } from "react-hot-toast";
import { SearchIcon } from "../../../Icon";
import MasterDataCommonTable from "../../MasterDataCommonTable/MasterDataCommonTable";
import { TCS_MODULE_HEADERS } from "../../../../constant/tableHeadersConstants/masterDataContants/masterDataClientGroupListConst";
import { EmptyList } from "../../../../assets/images";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import {
  deleteMasterTcsModuleAction,
  getMasterTcsModuleAction,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  resetTcsModuleList,
  resetTcsSingleData,
} from "../../../../redux/masterData";
import { resetTotalCount } from "../../../../redux/fileManager";
import { connect } from "react-redux";
import TdsMasterSorting from "../TdsMasterSorting";

type AppProps = {
  activeTab: any;
  isAddTcsPresent: boolean;
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  tcsDataList: TCSDetailsType[] | [];
  tcsDataTotalCount: number;
  isGetTcsListPresent: boolean;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetTcsList: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetSingleTcsDataAction: () => void;
  dispatchGetTcsModuleAction: (data: GetTdsMasterPayloadType) => void;
  dispatchDeleteTcsModuleAction: (data: DeleteTcsPayloadType) => void;
};
const TcsMasterListing = ({
  activeTab,
  fetching,
  message,
  success,
  history,
  error,
  token,
  statusCode,
  dispatchResetMasterError,
  dispatchResetTcsList,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetSingleTcsDataAction,
  tcsDataList,
  tcsDataTotalCount,
  dispatchGetTcsModuleAction,
  dispatchDeleteTcsModuleAction,
  isAddTcsPresent,
  isGetTcsListPresent,
}: AppProps) => {
  const persistSearchValue = history?.location?.state?.searchValue;
  const persistSortBy = history?.location?.state?.sortBy;
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchValue, setSearchValue] = useState(persistSearchValue);
  const [deleteId, setDeleteId] = useState("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState(
    persistSortBy
      ? persistSortBy
      : {
          id: "Newest first",
          value: "",
          _id: "",
          name: "Newest first",
        }
  );
  //====================User Management=============================
  // const [isAddTdsMasterPresent, setIsAddTdsMasterPresent] = useMenuCheck();
  const [isEditTcsMasterPresent, setIsEditTcsMasterDepartmentPresent] =
    useMenuCheck();
  const [isDeleteTcsMasterPresent, setIsDeletedTcsMasterPresent] =
    useMenuCheck();
  //=================================================================
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    // setIsAddTdsMasterPresent("Add TDS Master", "menu");
    setIsEditTcsMasterDepartmentPresent("Update TCS", "menu");
    setIsDeletedTcsMasterPresent("Delete TCS", "menu");
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetTcsList();
    dispatchResetMasterStatusCode();
  }, []);

  useEffect(() => {
    if (tcsDataList?.length === 0) {
      setData(tcsDataList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...tcsDataList]);
    } else {
      setData(tcsDataList);
    }
  }, [tcsDataList]);

  useEffect(() => {
    let sortingBy = sortBy?._id?.split("#");
    let finalData = {
      offset: 0,
      limit,
      token,
      searchValue: searchValue?.trim(),
      sortBy: sortingBy?.length ? sortingBy[0] : "",
      sortByValue: sortingBy?.length ? sortingBy[1] : "",
    };
    setIsApiCall(true);
    dispatchGetTcsModuleAction(finalData);
  }, [sortBy]);

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    dispatchResetMasterError();
    if (token && isApiCall) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData: GetTdsMasterPayloadType = {
        token,
        limit,
        offset,
        searchValue: searchValue?.trim(),
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortByValue: sortingBy?.length ? sortingBy[1] : "",
      };
      if (clearFilter) {
        setClearFilter(false);
      }
      if (tcsDataTotalCount) {
        if (offset < tcsDataTotalCount) {
          dispatchGetTcsModuleAction(finalData);
          setIsApiCall(true);
        }
      } else {
        dispatchGetTcsModuleAction(finalData);
        setIsApiCall(true);
      }
    }
  }, [offset, clearFilter]);

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  useDebounce(
    () => {
      if (isApiCall) {
        if (searchValue) {
          fetchNewData();
        } else {
          dispatchResetMasterSuccess();
          dispatchResetMasterMessage();
          if (offset > 0) {
            setOffset(0);
          } else {
            let sortingBy = sortBy?._id?.split("#");
            let finalData: any = {
              token,
              limit,
              offset: 0,
              searchValue: "",
              sortBy: sortingBy?.length ? sortingBy[0] : "",
              sortByValue: sortingBy?.length ? sortingBy[1] : "",
            };
            dispatchGetTcsModuleAction(finalData);
          }
        }
      }
    },
    500,
    [searchValue]
  );

  const fetchNewData = () => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    dispatchResetTcsList();
    if (token) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        searchValue: searchValue?.trim(),
        limit,
        offset,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortByValue: sortingBy?.length ? sortingBy[1] : "",
      };
      if (offset === 0) {
        dispatchGetTcsModuleAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleSearch = (e: any) => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    let value = e.target.value;
    setSearchValue(value);
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < tcsDataTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (tcsDataList?.length > 0) {
          if (!fetching && offset < tcsDataTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [tcsDataList]);

  const handleAddTcsMaster = () => {
    history.push({
      pathname: "/master-data/tds-and-tcs-master/add-tcs",
      state: { searchValue: searchValue?.trim(), sortBy, activeTab },
    });
  };

  const handleEditTcsMaster = (itemData: any) => {
    dispatchResetSingleTcsDataAction();
    history.push({
      pathname: `/master-data/tds-and-tcs-master/edit-tcs/${itemData?.tcs_id}`,
      state: { searchValue: searchValue?.trim(), sortBy, activeTab },
    });
  };

  const handleSort = (data: any) => {
    setOffset(0);
    setSortBy(data);
  };

  const handleDeleteTcsMaster = (deleteId: string) => {
    if (token && deleteId) {
      const finalData = {
        token,
        tcsId: deleteId,
      };
      dispatchDeleteTcsModuleAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully")) {
      dispatchResetTcsList();
      dispatchResetMasterError();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      dispatchResetMasterStatusCode();
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        limit,
        offset,
        searchValue: searchValue?.trim(),
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortByValue: sortingBy?.length ? sortingBy[1] : "",
      };
      if (offset === 0) {
        dispatchGetTcsModuleAction(finalData);
      }
    }
    if (success === 1 && message?.includes("deleted successfully!")) {
      dispatchResetTcsList();
      dispatchResetMasterError();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      dispatchResetMasterStatusCode();
      toast.success("TCS has been deleted successfully!", {
        duration: 2000,
      });
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        limit,
        offset,
        searchValue: searchValue?.trim(),
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortByValue: sortingBy?.length ? sortingBy[1] : "",
      };
      if (offset === 0) {
        dispatchGetTcsModuleAction(finalData);
      }
    }
    return false;
  };

  const handleDeleteConfirmationModal = () => {
    setShowDeleteConfirmationModal(!showDeleteConfirmationModal);
  };

  const handleDelete = (id: string) => {
    setDeleteId(id);
    setShowDeleteConfirmationModal(true);
  };
  return (
    <div className="row">
      {isGetTcsListPresent && (
        <div className="col-md-12">
          <div className="jobs-card">
            <div className="header">
              <div className="left-header">
                <div className="heading">TCS Master Listing</div>
                {!fetching && tcsDataTotalCount > 0 && (
                  <div
                    className="sub-heading"
                    style={{ marginTop: "-22px" }}
                  >{`Total ${
                    tcsDataTotalCount ? tcsDataTotalCount : 0
                  } TCS list found`}</div>
                )}
              </div>
              <div className="right-header">
                <div
                  className={`${
                    !!tcsDataList?.length ? "col-md-10" : "col-md-10"
                  } position-relative`}
                >
                  <span
                    style={{ position: "absolute", top: "8px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    onChange={(e) => handleSearch(e)}
                    style={{ paddingLeft: "35px" }}
                    value={searchValue}
                  />
                </div>
                <div className="mr-2">
                  <TdsMasterSorting
                    handleChange={handleSort}
                    selectedData={sortBy}
                    type={"tcs"}
                  />
                </div>
              </div>
            </div>
            <>
              {fetching && offset == 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : tcsDataList?.length > 0 ? (
                <MasterDataCommonTable
                  data={data}
                  handleEditMasterData={handleEditTcsMaster}
                  fetching={fetching}
                  offset={offset}
                  type="tcs"
                  tableHeader={TCS_MODULE_HEADERS}
                  handleDelete={handleDelete}
                  isEditPresent={isEditTcsMasterPresent}
                  isDeletePresent={isDeleteTcsMasterPresent}
                />
              ) : (
                <div className="mt-5 pb-5">
                  {!fetching && data?.length === 0 && (
                    <EmptyListPage
                      title="No TCS List Found!"
                      image={EmptyList}
                      imageWidth="30%"
                      showAddButton={isAddTcsPresent}
                      buttonTitle={isAddTcsPresent ? "+ Add TCS" : ""}
                      onButtonClick={handleAddTcsMaster}
                    />
                  )}
                </div>
              )}
            </>
          </div>
        </div>
      )}
      {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
      <div style={{ display: fetching ? "none" : "inline" }}>
        <ScrollToTop />
      </div>
      {showDeleteConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleDeleteConfirmationModal();
          }}
          isOpen={showDeleteConfirmationModal}
          title={`Delete TCS?`}
          message={`Are you sure you want to Delete?`}
          confirmButtonText="Delete"
          onPressConfirm={() => {
            handleDeleteTcsMaster(deleteId);
            handleDeleteConfirmationModal();
          }}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  tcsDataList: state.masterData.tcsDataList,
  tcsDataTotalCount: state.masterData.totalCount,
  success: state.masterData.success,
  message: state.masterData.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetTcsList: () => dispatch(resetTcsModuleList()),
  dispatchResetTotalCount: () => dispatch(resetTotalCount()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetSingleTcsDataAction: () => dispatch(resetTcsSingleData()),
  dispatchGetTcsModuleAction: (data: GetTdsMasterPayloadType) =>
    dispatch(getMasterTcsModuleAction(data)),

  dispatchDeleteTcsModuleAction: (data: DeleteTcsPayloadType) =>
    dispatch(deleteMasterTcsModuleAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TcsMasterListing);
